var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('a',{staticClass:"external",attrs:{"href":_vm.link,"target":"_blank","rel":"noopener noreferrer"}},[_c('strong',[_vm._v(_vm._s(_vm.name))])]):_c('strong',[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []

export { render, staticRenderFns }